import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import createHistory from 'history/createHashHistory';
const history = createHistory();
import NHFetch from "@utils/NHFetch";
/*页面*/
import Index from '@pages/index'

export default class IndexRoute extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            dhlm:{},
            nextUrl:'index',
        }
    }

    componentWillMount(){
        this.loadMrlm();
    }

    shouldComponentUpdate(nextProps,nextState){
        let dhlm = nextState.dhlm;
        if(JSON.stringify(this.state.dhlm)=='{}' && JSON.stringify(nextState.dhlm)!='{}'){
            let lmlx = dhlm['lmlx'];
            let flbz = dhlm['flbz'];
            let mkbz = dhlm['mkbz'];
            let flmid = dhlm['flmid'];
            let lmlj = dhlm['lmlj'];
            let pkid = dhlm['pkid'];
            if(lmlx==3){
                history.push({
                        pathname:mkbz
                    }
                );
            }else if(lmlx==1){
                history.push({
                        pathname:'notice',
                        search:'flbz='+flbz,
                    }
                );
            }else if(lmlx==2){
                if(flmid==-1){

                }else{
                    history.push({
                            pathname:'link',
                            search:'pkid='+pkid,
                        }
                    );
                }
                window.open(lmlj);
            }
        }
        return true;
    }

    loadMrlm=()=>{
        NHFetch("front/zhxg-unauth/yxwz/getDhlmMrlm","GET")
            .then(resData => {
                if(resData && resData.data){
                    this.setState({dhlm:resData.data});
                }
            });
    }

    render() {
        return (
            <Index/>
        );
    }
}


// WEBPACK FOOTER //
// ./app/pages/index/IndexRoute.js